import React from 'react';
import { Heart, Gift } from 'lucide-react';

const WeddingsHero = () => (
  <section className="relative py-20 text-white overflow-hidden">
    <div className="absolute inset-0 w-full h-full">
      <div className="relative w-full h-full grid grid-cols-3">
        <div className="w-full h-full overflow-hidden">
          <img
            src="https://customer-assets.emergentagent.com/job_lokal-landing/artifacts/6a965ui4_Website%20Wedding%20Pictures.svg"
            alt="Wedding celebration"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="w-full h-full overflow-hidden">
          <img
            src="https://customer-assets.emergentagent.com/job_lokal-landing/artifacts/1wy5c3nv_Website%20Wedding%20Pictures%20%281%29.svg"
            alt="Wine bottles"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="w-full h-full overflow-hidden">
          <img
            src="https://customer-assets.emergentagent.com/job_lokal-landing/artifacts/3wvlnq3h_Website%20Wedding%20Pictures%20%282%29.svg"
            alt="Wedding venue"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <Heart className="w-16 h-16 mx-auto mb-6 text-[#FDB913]" />
        <h1 className="text-4xl md:text-5xl font-bold mb-6">Wedding & Event Packages</h1>
        <p className="text-xl max-w-3xl mx-auto mb-8 opacity-90">
          Make your special day even more memorable with custom-labeled wines from The Lokal Winery
        </p>
        <div className="inline-flex items-center gap-3 bg-[#FDB913] text-gray-900 px-6 py-4 rounded-lg font-semibold text-lg">
          <Gift className="w-6 h-6" />
          <span>FREE Wedding Planner PDF with Every Booking!</span>
        </div>
      </div>
    </div>
  </section>
);

export default WeddingsHero;
